import React, { createContext, useReducer } from 'react';
import { initLoginState, loginReducer } from './reducers/login';
import { initJobsState, jobsReducer } from './reducers/jobs';
export const LineworxStateContext = createContext();
export const LineworxDispatchContext = createContext();

const initState = {
  jobs: initJobsState,
  login: initLoginState

}

const reducer = (state, action) => {
    switch (action.section) {
      case 'jobs':
        return jobsReducer(state, action);
      case 'login':
        return loginReducer(state, action);
      default: 
        throw new Error(`${action.section} action.section passed to Lineworx reducer is not defined`);
    }
}

const LineworxProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initState);

    return (
        <LineworxDispatchContext.Provider value={dispatch}>
            <LineworxStateContext.Provider value={state}>
                {children}
            </LineworxStateContext.Provider>
        </LineworxDispatchContext.Provider>
    )
}

export default LineworxProvider;